<template>
  <div style="height: 100%;width: 100%">
    <el-header>
      <el-form :model="formData" label-width="10px">
        <el-row>
          <el-form-item>
            <el-select v-model="formData.wuJianId" style="width:200px ;" clearable placeholder="物件名称">
              <el-option
                  v-for="item in wuJianNames"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="formData.day" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month"
                            placeholder="选择月份" :clearable="false"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="searchLoading" @click="getZuliActualProductive">搜索</el-button>
          </el-form-item>
          <!--<el-button type="primary" plain style="width: 80px" :loading="exportLoading" @click="exportProduction">导出</el-button>-->
        </el-row>
      </el-form>
    </el-header>

    <el-table :data="tableData" border style="width: 100%;height:78%;margin-top: 10px">
      <el-table-column prop="name" label="日期" width="180" fixed/>
      <el-table-column prop="total" label="合计" width="120" fixed/>
      <el-table-column v-for="item in countDayList" :key="item" :prop="item" :label="item" width="80">
        <template v-slot="scope">
          {{ scope.row.dataList[item - 1] }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "AssemblyProductive",
  data() {
    return {
      wuJianNames: [],
      formData: {
        day: this.getDateFormat(),
        wuJianId: ''
      },
      searchLoading: false,
      resetLoading: false,
      exportLoading: false,
      countDayList: [],
      tableData: [],
      total: 0,
      pageNo: 1,

    }
  }, methods: {
    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('mfg/wujianPlan/getWujianName');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },
    //生产性
    getZuliActualProductive() {
      this.searchLoading = true;
      this.$axios.post('mfg/zuliProductive/getZuliActualProductive', this.formData).then(response => {
        let res = response.data
        if (res.code === 0) {
          this.tableData = res.data.zuliActualProductionList
          this.countDayList = res.data.dayList
          this.searchLoading = false;
        }
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    exportProduction() {
      this.exportLoading = true;
      let exportDate = {tableDate: this.tableData, countDayList: this.countDayList}
      this.$axios.post('mfg/zuliProductive/exportProduction', exportDate).then(response => {
        this.exportLoading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("导出失败" + res.message);
        }

        console.log("res:==", res)
        const url = res.data.data.url;
        const originalName = res.data.data.originalName;
        if (url) {
          const link = document.createElement('a');
          link.href = url;
          link.download = originalName || '' // 下载文件的名字
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }
        return this.$message.success("导出成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
  }, created() {
    this.getWuJianInFo()
    this.getZuliActualProductive()

  }
}
</script>

<style scoped>
.padding {
  padding: 5px;
}

.pageStyle {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0
}

.el-table :deep(.cell) {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 0 12px;
  text-align: center;
}
</style>